export const CORE_CHAIN = 43114;
export const GAME_CHAIN = 43288;
export const BURN_ADDRESS = '0x0000000000000000000000000000000000000001';
export const DEV_MODE = process.env.NODE_ENV === 'development';
export const DEV_TEST_ADDRESS = DEV_MODE ? '' : '';
export const FILLER_ADDRESS = '0x0000000000000000000000000000000000000002';
// wizbliz wallet: 0xCaD8E3976d5899bE97Bf274891f81402355Ff5a7
// dcr wallet: 0x4082e997Ec720A4894EFec53b0d9AabfeeA44cBE
